import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-how-smart-classroom-solutions-help-schools-increase-admissions',
  templateUrl: './how-smart-classroom-solutions-help-schools-increase-admissions.component.html',
  styleUrls: ['./how-smart-classroom-solutions-help-schools-increase-admissions.component.scss']
})
export class HowSmartClassroomSolutionsHelpSchoolsIncreaseAdmissionsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('How Virsa Smart Classroom Solutions Help Schools Increase Admissions in 2026 | VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Discover how VIRSA Smart Classroom Solutions help schools improve admissions through interactive classrooms, AI-powered learning, digital infrastructure, and modern teaching technology.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'smart classroom solutions India, smart classrooms for schools, increase school admissions, interactive flat panels for schools, digital classroom solutions, VIRSA smart classroom solutions, AI learning solutions for schools, K-12 digital learning India'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
